import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { getUserConfigStatus, getUserManagement, updateUser } from "./UserManagmentRepo"
import { showToast } from "../../../../utils/toastUtils"

interface ReqBodyInterfce{
  Name: string,
  Email: string,
  Phone: string,
  RoleId: number,
  Status: number
}

export const useGetUserList = ({enable=false,params}:{enable:boolean,params:any})=>{
    return useQuery({
        queryKey:['GET_USER_LIST',params],
        queryFn:()=>getUserManagement(params),
        retry:false,
        enabled:enable
    })
}

export const useUpdateUser = ()=>{
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn:({id,ReqBody}:{id:number,ReqBody:ReqBodyInterfce})=>updateUser(id,ReqBody),
      onSuccess:()=>{
           showToast.success('Succefully Updated');
           queryClient.invalidateQueries({ queryKey:['GET_USER_LIST']})
      },
      onError:(error:any)=>{
       showToast.error('Falied to Update');
       console.log(`Flied to update ${error.message}`);
      }
    })
} 


export const Use_getUserConfigStatus = ({enable=false})=>{
    return useQuery({
        queryKey:['GET_CONFIG_STATUS'],
        queryFn:getUserConfigStatus,
        retry:false,
        enabled:enable
    })
}
